import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { SpecificComponent } from '../specific.component';
import { CompInstanceSearchResult } from 'src/app/_common/models/search-result';
import { Bytes } from 'src/app/_common/enum';

@Component({
    selector: 'aa-search-result-comp-instance',
    templateUrl: './comp-instance.component.html',
    styleUrls: [
        '../specific-shared.scss',
        '../../../../../../customer/comp/instances/instances-list/columns-shared.scss',
        './comp-instance.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CompInstanceComponent extends SpecificComponent<CompInstanceSearchResult> implements OnInit
{
    bytesMibi: Bytes = Bytes.MIBI;
    bytesGibi: Bytes = Bytes.GIBI;

    constructor()
    {
        super();
    }

    ngOnInit ()
    {
    }
}
